import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import text from '../../../../constants/text';
import { supportURL } from '../../../../constants/general';

export default class NoRateFound extends PureComponent {
  _renderContent () {
    if (this.props.use_custom_rate) {
      return text.warning.noCustomRateFound;
    }

    return (
      <Fragment>
        <p>We're sorry but the job location is outside of where we operate.</p>
        <p>Contact <a href={`mailto:${supportURL}`} className='support-email-link'>{supportURL}</a> to see if they can assist you for this special case.</p>
      </Fragment>
    );
  }

  render () {
    return (
      <div className='location-outside-message'>
        {this._renderContent()}
      </div>
    );
  }
}

NoRateFound.propTypes = {
  use_custom_rate: PropTypes.bool
};

NoRateFound.defaultProps = {
  use_custom_rate: false
};



// WEBPACK FOOTER //
// ./src/components/app/createJob/common/NoRateFound.js